import {
  getLevelType,
  setLevelType,
  getLevelActive,
  setLevelActive,
  getLevelActiveIndex,
  setLevelActiveIndex,
} from "@/utils/cache";
import { fetchLastLevelSelect, saveLevelSelect } from "@/serves/api/level";
import { calcLevelActive } from "@/utils/helper";

// 等级信息
const level = {
  namespaced: true,
  state: {
    // 全部等级列表
    levelList: [],
    // 当前等级类型
    levelType: getLevelType() || "",
    // 当前等级id
    levelActive: getLevelActive() || "",
    // 当前等级index
    levelActiveIndex: getLevelActiveIndex() || "",
    // 当前level id
    levelId: 0,
  },
  getters: {
    // 当前等级选择详情
    levelActiveObj(state) {
      const level = state.levelList?.find((item) => item.level_type == state.levelType);
      const active = level?.levels?.find((item) => item.id == state.levelActive);
      return active || {};
    },
    levelTypeName(state) {
      return state.levelList?.find((item) => item.level_type == state.levelType)?.type_name?.toLowerCase() || null;
    },
  },
  mutations: {
    SET_LEVEL_LIST(state, payload) {
      state.levelList = Array.isArray(payload) ? payload : [];
    },
    SET_LEVEL_ACTIVE(state, payload) {
      const { levelType, levelId, levelIndex } = payload;
      setLevelType(levelType);
      state.levelType = levelType;
      setLevelActive(levelId);
      state.levelActive = levelId;
      setLevelActiveIndex(levelIndex);
      state.levelActiveIndex = levelIndex;
      console.log('SET_LEVEL_ACTIVE',payload)
    },
    SET_LEVEL_ID(state, payload) {
      console.log(payload,'SET_LEVEL_ID++++++++++++++++++++++++++++')
      state.levelId = payload;
    },
    SET_LEVEL_TYPE_NAME(state, payload) {
      state.levelTypeName = payload;
    },
  },
  actions: {
    refreshLevelList({ commit }) {
      return new Promise((resolve) => {
        const pLevelList = new Promise((resolve) => {
          window.utilV2.getData(
            window.ApiPath.hsk_level_list,
            {},
            (data) => {
              const rebuildData = data.map((item) => {
                return {
                  ...item,
                  level_type: `${item.level_type}`,
                };
              });
              resolve(rebuildData);
            },
            null,
            { showLoading: false },
          );
        });
        const pLevelSelect = fetchLastLevelSelect();

        Promise.all([pLevelList, pLevelSelect]).then(([levelListData, levelSelectData]) => {
          commit("SET_LEVEL_LIST", levelListData);
          console.log(window.location.pathname, 'window.location.pathname')
          const levelActiveId = levelSelectData.data?.level_id;
          commit("SET_LEVEL_ID", levelActiveId);
          const { levelType, levelId, levelIndex } = calcLevelActive(levelListData, levelActiveId);
          console.log('store refreshLevelList')
          commit("SET_LEVEL_ACTIVE", { levelType, levelId, levelIndex });
          resolve();
        });
      });
    },
    changeLevel({ commit }, payload) {
      return new Promise((resolve) => {
        const { levelType, levelId, levelIndex } = payload;
        setTimeout(() => { 
          commit("SET_LEVEL_ID", levelId);
          saveLevelSelect({ level_id: levelId }).then(() => {
          console.log('store changeLevel')
          commit("SET_LEVEL_ACTIVE", { levelType, levelId, levelIndex });
          resolve();
        });
        },500)
      });
    },
  },
};

export default level;
